<template>
  <el-popover placement="bottom" width="400" trigger="manual" v-model="visible" popper-class="tab-uploader">
    <upload :showList="true"/>
    <div
      class="btn-text can-hover"
      type="text"
      slot="reference"
      @click="visible = !visible"
    >
      <el-badge :value="number" :hidden="number === 0">
        <i class="fa fa-cloud-upload"></i>
      </el-badge>
    </div>
  </el-popover>
</template>
<script>
import upload from '@/components/upload'
import { mapGetters } from 'vuex'
export default {
  components: {
    upload,
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    ...mapGetters('admin/upload',['number'])
  },
  watch: {
    number(val) {
      this.visible = val > 0
    },
  },
}
</script>
<style lang="scss">
.tab-uploader .global-uploader {
  border-radius: none;
  box-shadow: none;
  border: none;
}
</style>
